import { render, staticRenderFns } from "./DashboardCasks.vue?vue&type=template&id=610e9746&"
import script from "./DashboardCasks.vue?vue&type=script&lang=js&"
export * from "./DashboardCasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports